import { render, staticRenderFns } from "./PriceSlider.vue?vue&type=template&id=79fd8dd5&scoped=true"
import script from "./PriceSlider.vue?vue&type=script&lang=js"
export * from "./PriceSlider.vue?vue&type=script&lang=js"
import style0 from "./PriceSlider.vue?vue&type=style&index=0&id=79fd8dd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fd8dd5",
  null
  
)

export default component.exports